import { AbstractNodeProgram } from 'sigma/rendering';

export class NoopNodeProgram extends AbstractNodeProgram {
  drawHover = undefined;
  drawLabel = undefined;
  kill() {}
  process() {}
  reallocate() {}
  render() {}
}
